import { components } from "@/api-schema";
import { ImplementedAccessorColumnDef } from "../types";
import { commonColumns } from "./_constants/common-columns";

type GroupWithAppRoleTableType = components["schemas"]["GroupWithAppRoleResponseDto"];

export const groupWithAppRoleTableDefaultColumns = {
  columnName: {
    ...commonColumns.columnName<GroupWithAppRoleTableType>(),
    size: 500,
  } as ImplementedAccessorColumnDef<GroupWithAppRoleTableType>,
};
